import { atom } from 'recoil';
import DeliveryOrder from 'src/interfaces/api/DeliveryOrder';

export default atom({
  key: 'deliveryOrders',
  default: {} as { [key: string]: DeliveryOrder },
});
